@if ((incomeTaxEntity$ | async)) {
  @if (ondernemingen.length > 0) {
    <form [formGroup]="formGroup">
      <div formArrayName="ondernemingen">
        @for (item of ondernemingen.controls; track item; let i = $index) {
          @if (i === indexOnderneming) {
            <div [formGroupName]="i">

              @if (item.get('ondernemingsvorm')?.value !== Ondernemingsvorm.EENMANSZAAK) {
                <div class="row">
                  <div class="col-7">
                    <p>Wat is het RSIN van het samenwerkingsverband?</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-bsn-form-control class="custom-input-150"
                                                   formControlName="rsin"
                                                   label=""
                                                   id="rsin"
                    >
                    </snelstart-ui-bsn-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
              }

              @if (item.get('ondernemingsvorm')?.value !== Ondernemingsvorm.EENMANSZAAK) {
                <div class="row">
                  <div class="col-7">
                    <p>Wil je cijfers invullen op het niveau van het samenwerkingsverband?</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                      class="custom-input-150"
                                                      formControlName="invullenOpNiveauSamenwerkingsverband"
                                                      id="invullenOpNiveauSamenwerkingsverband"
                    >
                    </snelstart-ui-select-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
              }

              <div class="row">
                <div class="col-7">
                  <p>Is er sprake van winst uit onderneming als medegerechtigde of schuldeiser?</p>
                </div>
                <div class="col-2">
                  <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                    class="custom-input-150"
                                                    formControlName="medegerechtigdeOfSchuldeiser"
                                                    id="medegerechtigdeOfSchuldeiser"
                  >
                  </snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
              </div>

              <div class="row">
                <div class="col-7">
                  <p>Is er sprake van winst uit hoofde van een schuldvordering?</p>
                </div>
                <div class="col-2">
                  <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                    class="custom-input-150"
                                                    formControlName="winstUitHoofdeVanSchuldvordering"
                                                    id="winstUitHoofdeVanSchuldvordering"
                  >
                  </snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
              </div>

              <div>
                <div class="row">
                  <div class="col-7">
                    <p>
                      Verricht de onderneming agrarische activiteiten?</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNeeAgra"
                                                      class="custom-input-150"
                                                      formControlName="agrarischeActiviteiten"
                                                      id="agrarischeActiviteiten"
                    >
                    </snelstart-ui-select-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                <div class="row">
                  <div class="col-7">
                    <p>Is er sprake van het wijzigen van een waarderingsstelsel?</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                      class="custom-input-150"
                                                      formControlName="waarderingsstelselGewijzigd"
                                                      id="waarderingsstelselGewijzigd"
                    >
                    </snelstart-ui-select-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                <div class="row">
                  <div class="col-7">
                    <p>Is er sprake van willekeurige afschrijving?</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                      class="custom-input-150"
                                                      formControlName="willekeurigAfgeschreven"
                                                      id="willekeurigAfgeschreven"
                    >
                    </snelstart-ui-select-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                <div class="row">
                  <div class="col-7">
                    <p>Is er sprake van een schadeloosstelling buiten de winst om?</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                      class="custom-input-150"
                                                      formControlName="schadeloosstellingBuitenWinstOm"
                                                      id="schadeloosstellingBuitenWinstOm"
                    >
                    </snelstart-ui-select-form-control>
                  </div>
                  <div class="col-3"></div>
                  <!--                <div *ngIf="onderneming.get('schadeloosstellingBuitenWinstOm')?.value === true" class="col-2">-->
                  <!--                  <snelstart-ui-button (click)="this.showDialog()"-->

                  <!--                                       class="custom-input-150"-->
                  <!--                                       icon="plus"-->
                  <!--                                       type="secondary">-->
                  <!--                    Specificeer-->
                  <!--                  </snelstart-ui-button>-->
                  <!--                </div>-->
                  <!--                <div *ngIf="onderneming.get('schadeloosstellingBuitenWinstOm')?.value === false"-->
                  <!--                     class="col-2"></div>-->
                  <!--                <div class="col-4"></div>-->
                </div>

                <div class="row">
                  <div class="col-7">
                    <p>Is de onderneming gestart in {{ (incomeTaxEntity$ | async)?.year }}? Vul
                      dan de startdatum in.</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-date-form-control class="custom-input-150"
                                                    formControlName="startOnderneming"
                                                    id="startOnderneming"
                                                    label=""
                                                    placeholder="dd-mm-jjjj"
                    >
                    </snelstart-ui-date-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                <div class="row">
                  <div class="col-7">
                    <p>Is de onderneming gestaakt in {{ (incomeTaxEntity$ | async)?.year }}? Vul
                      dan de stakingsdatum in.</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-date-form-control class="custom-input-150"
                                                    formControlName="datumStaking"
                                                    id="datumStaking"
                                                    label=""
                                                    placeholder="dd-mm-jjjj"
                    >
                    </snelstart-ui-date-form-control>
                  </div>
                  <div class="col-3"></div>

                  <!--                @if (onderneming.get('datumStaking')?.value) {-->
                  <!--                  <div class="col-auto" style="padding-top: 0.2rem">-->
                  <!--                                    <span (mouseenter)="showHelp('staking')"-->
                  <!--                                          (mouseleave)="hideHelp()"-->
                  <!--                                          class="help-toggle">ⓘ</span>-->
                  <!--                  </div>-->
                  <!--                  @if (activeHelp === 'staking') {-->
                  <!--                    <div (mouseenter)="showHelp('staking')"-->
                  <!--                         (mouseleave)="hideHelp()"-->
                  <!--                         class="help-inline">-->
                  <!--                      Is er sprake van winst behaald bij of met staking? Vul dan in de Resultatenrekening-->
                  <!--                      het-->
                  <!--                      bedrag aan stakingswinst in bij de post 'Stakingswinsten'. <br/>Daarmee wordt dan-->
                  <!--                      ook-->
                  <!--                      bepaald of en hoeveel recht er is op stakingsaftrek. Je vindt de (eventuele)-->
                  <!--                      stakingsaftrek bij het onderdeel 'Samenvatting'.-->
                  <!--                    </div>-->
                  <!--                  }-->
                  <!--                }-->
                </div>

                @if ((incomeTaxEntity$ | async)?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.datumStaking) {
                  <div formGroupName="staking">
                    <div class="row">
                      <div class="col-7">
                        <p>Is er sprake van een staking door overdracht van de onderneming?</p>
                      </div>
                      <div class="col-2">
                        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                          class="custom-input-150"
                                                          formControlName="stakingDoorOverdrachtOnderneming"
                                                          id="stakingDoorOverdrachtOnderneming"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                      <div class="col-3"></div>
                    </div>

                    <div class="row">
                      <div class="col-7">
                        <p>Is er sprake van overdracht van een onroerende zaak naar een derde of
                          naar prive?</p>
                      </div>
                      <div class="col-2">
                        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                          class="custom-input-150"
                                                          formControlName="overdrachtOnroerendeZakenNaarPrive"
                                                          id="overdrachtOnroerendeZakenNaarPrive"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                      <div class="col-3"></div>
                    </div>

                    <div class="row">
                      <div class="col-7">
                        <p>Is er sprake van overdracht van overige activa naar prive?</p>
                      </div>
                      <div class="col-2">
                        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                          class="custom-input-150"
                                                          formControlName="overdrachtOverigeBestanddelenNaarPrive"
                                                          id="overdrachtOverigeBestanddelenNaarPrive"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                      <div class="col-3"></div>
                    </div>

                    <div class="row">
                      <div class="col-7">
                        <p>Is er sprake van inbreng van de onderneming in een BV?</p>
                      </div>
                      <div class="col-2">
                        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                          class="custom-input-150"
                                                          formControlName="overdrachtNaarBV"
                                                          id="overdrachtNaarBV"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                      <div class="col-3"></div>
                    </div>

                    <div class="row">
                      <div class="col-7">
                        <p>Is er sprake van geruisloze inbreng van de onderneming in de BV?</p>
                      </div>
                      <div class="col-2">
                        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                          class="custom-input-150"
                                                          formControlName="doorschuivenGeruisloosInbrengInBV"
                                                          id="doorschuivenGeruisloosInbrengInBV"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                      <div class="col-3"></div>
                    </div>

                    <div class="row">
                      <div class="col-7">
                        <p>Is er sprake van geruisloze doorschuiven naar een
                          mede-ondernemer?</p>
                      </div>
                      <div class="col-2">
                        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                          class="custom-input-150"
                                                          formControlName="doorschuivenGeruisloosNaarMedeOndernemer"
                                                          id="doorschuivenGeruisloosNaarMedeOndernemer"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                      <div class="col-3"></div>
                    </div>

                    <div class="row">
                      <div class="col-7">
                        <p>Is er sprake van geruisloze doorschuiven in verband met overlijden
                          van de ondernemer?</p>
                      </div>
                      <div class="col-2">
                        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                          class="custom-input-150"
                                                          formControlName="doorschuivenGeruisloosDoorOverlijden"
                                                          id="doorschuivenGeruisloosDoorOverlijden"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                      <div class="col-3"></div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    </form>
  } @else {
    <p>Er zijn geen ondernemingen gevonden.</p>
  }
}


<!--    <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg"-->
<!--                                    size="lg"-->
<!--                                    title="Specificatie schadeloosstelling buiten winst om">-->
<!--        <snelstart-ui-dialog-header-content>-->
<!--            Er kan bijvoorbeeld sprake zijn van een schadevergoeding bij onteigening van een pand of-->
<!--            van grond.<br/> Deze schadevergoeding wordt <b>niet</b> opgenomen in de resultatenrekening, omdat hierover-->
<!--            geen inkomstenbelasting verschuldigd is.-->
<!--        </snelstart-ui-dialog-header-content>-->

<!--        <snelstart-ui-dialog-body>-->

<!--            <form [formGroup]="ondernemingFG">-->
<!--                <div formArrayName="ondernemingen">-->
<!--                    <div *ngFor="let onderneming of ondernemingen.controls; let i = index "-->
<!--                         [formGroupName]="i">-->
<!--                        <div *ngIf="i === this.index">-->
<!--                            <div class="flex-container-dialog">-->
<!--                                <div formArrayName="schadeloosstellingBuitenWinst">-->
<!--                                    <div *ngFor="let schade of getSchadeloosstelling(i).controls; let s = index "-->
<!--                                         [formGroupName]="s" class="row">-->
<!--                                        <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                                        [label]="s === 0 ? 'Omschrijving' : ''"-->
<!--                                                                        class="col-auto custom-input-250"-->
<!--                                                                        formControlName="omschrijving"-->
<!--                                                                        id="omschrijving"-->
<!--                                        >-->
<!--                                        </snelstart-ui-text-form-control>-->
<!--                                        <snelstart-ui-number-form-control (change)="saveForm()"-->
<!--                                                                          [decimals]="0"-->
<!--                                                                          [label]="s === 0 ? 'Bedrag' : ''"-->
<!--                                                                          align="right"-->
<!--                                                                          class="col-auto custom-input-150"-->
<!--                                                                          formControlName="bedrag"-->
<!--                                                                          id="bedrag"-->
<!--                                                                          prefix="€"-->

<!--                                        >-->
<!--                                        </snelstart-ui-number-form-control>-->
<!--                                        <div class="col-auto">-->
<!--                                            <snelstart-ui-button (click)="verwijderSchadeloosstelling(i, s)"-->
<!--                                                                 [class]="s === 0 ? 'firstrowbutton ' : ''"-->
<!--                                                                 class="delete"-->
<!--                                                                 icon="trash"-->
<!--                                                                 id="buttonDelete"-->
<!--                                                                 size="medium"-->
<!--                                                                 type="secondary"-->
<!--                                            >-->
<!--                                            </snelstart-ui-button>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <div *ngIf="getSchadeloosstelling(i).length === 0 || getSchadeloosstelling(i).getRawValue()===null">-->
<!--                                    <snelstart-ui-button-->
<!--                                            (click)="addSchadeloosstelling(i)"-->
<!--                                            class="snelstart-ui-button pt-1 pb-3"-->
<!--                                            icon="plus"-->
<!--                                            type="link">-->
<!--                                        Schadeloosstelling invullen-->
<!--                                    </snelstart-ui-button>-->
<!--                                </div>-->

<!--                                <div *ngIf="getSchadeloosstelling(i).length > 0">-->
<!--                                    <snelstart-ui-button-->
<!--                                            (click)="addSchadeloosstelling(i)"-->
<!--                                            class="snelstart-ui-button pb-3"-->
<!--                                            icon="plus"-->
<!--                                            type="link">-->
<!--                                        Schadeloosstelling toevoegen-->
<!--                                    </snelstart-ui-button>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </form>-->

<!--        </snelstart-ui-dialog-body>-->

<!--        <snelstart-ui-dialog-buttons class="d-flex">-->
<!--            <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren-->
<!--            </snelstart-ui-button>-->
<!--            <snelstart-ui-button (click)=saveForm() icon="check" id="save2" type="primary">-->
<!--                Akkoord-->
<!--            </snelstart-ui-button>-->
<!--        </snelstart-ui-dialog-buttons>-->
<!--    </snelstart-ui-dialog-definition>-->
